import Cookies from "universal-cookie";
import InterAxios from "../Service/InterAxios";

export const getArticle = async (slug) => {

    const cookies = new Cookies();
    const interAxios = new InterAxios('App', () => cookies.get('authtoken')?.token);

    return new Promise((resolve, reject) => {
        interAxios.get('/articles/slug/' + slug, function (response) {
            resolve(response.data);
        }, function (error) {
            reject(error.response?.data);
        });
    });

}